import React from 'react';
import ProcedureTab from './ProcedureTab';
import { PROCEDURE_CATEGORIES } from '../../types/ProcedureTypes';

interface OperationalTabProps {
    procedures: any[];
    loading: boolean;
    error: string | null;
    selectedProcedure: any;
    setSelectedProcedure: (procedure: any) => void;
    onRefresh?: () => void;
}

const OperationalTab: React.FC<OperationalTabProps> = (props) => {
    const config = {
        title: 'Operational Procedures',
        description: 'Ship operational procedures and guidelines',
        icon: 'fa-cogs',
        category: PROCEDURE_CATEGORIES.OPERATIONAL,
        columns: [
            {
                key: 'title',
                header: 'Title',
            },
        ],
    };

    return <ProcedureTab config={config} {...props} />;
};

export default OperationalTab;
